module.exports = "\r\n\r\n.body {\r\n\r\n    height: 300px;\r\n    margin-left: 100px;\r\n    padding-top: 50px;\r\n\r\n}\r\n"